// =============================================================================
// PRZEWODNIK PAROWANIA — pięć kroków od pustej licencji do działającego
// urządzenia. Stoi w zakładce „Przegląd", a nie przy każdej rodzinie: kroki są
// dla wszystkich rodzin te same (licencja → aplikacja → kod → wpisanie kodu),
// a powtórzony pod każdą zakładką byłby czterema kopiami do rozjechania.
// =============================================================================

import { CheckCircle2, ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

interface Props {
  otwarty: boolean;
  przelacz: () => void;
}

export function PrzewodnikParowania({ otwarty, przelacz }: Props) {
  return (
    <div className="mb-6 card overflow-hidden">
      <button
        onClick={przelacz}
        className="w-full flex items-center justify-between p-4 text-left hover:bg-aurora-bg-subtle transition-colors"
      >
        <div className="flex items-center gap-2">
          <HelpCircle className="w-5 h-5 text-aurora-brand" />
          <span className="text-sm font-medium text-aurora-text">Jak sparować urządzenie?</span>
        </div>
        {otwarty ? (
          <ChevronUp className="w-5 h-5 text-aurora-muted" />
        ) : (
          <ChevronDown className="w-5 h-5 text-aurora-muted" />
        )}
      </button>

      {otwarty && (
        <div className="px-4 pb-4 space-y-4">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-aurora-brand/20 text-aurora-brand flex items-center justify-center text-xs font-bold">
              1
            </div>
            <div>
              <p className="text-sm text-aurora-text font-medium">Dodaj nową licencję</p>
              <p className="text-xs text-aurora-muted mt-0.5">
                Kliknij „Nowa licencja", podaj nazwę urządzenia i wybierz moduły, do których ma mieć
                dostęp.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-aurora-brand/20 text-aurora-brand flex items-center justify-center text-xs font-bold">
              2
            </div>
            <div>
              <p className="text-sm text-aurora-text font-medium">
                Zainstaluj aplikację na urządzeniu
              </p>
              <p className="text-xs text-aurora-muted mt-0.5">
                Pobierz aplikację z zakładki tej rodziny urządzeń — zeskanuj kod QR tabletem albo
                pobierz instalator na peceta. Po sparowaniu i zalogowaniu pracownika aplikacja
                udostępnia licencjonowane moduły. Moduły bez natywnego widoku otwórz w przeglądarce:
              </p>
              <div className="mt-2 p-3 bg-aurora-brand/10 border border-aurora-brand/20 rounded-ids-md">
                <code className="text-sm text-aurora-brand mono font-medium">
                  universe.insolitum.ai/mobile
                </code>
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-aurora-brand/20 text-aurora-brand flex items-center justify-center text-xs font-bold">
              3
            </div>
            <div>
              <p className="text-sm text-aurora-text font-medium">Wygeneruj kod parowania</p>
              <p className="text-xs text-aurora-muted mt-0.5">
                Przy licencji ze statusem „Oczekuje" kliknij „Kod parowania". Otrzymasz jeden
                6-cyfrowy kod ważny przez 15 minut.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-aurora-brand/20 text-aurora-brand flex items-center justify-center text-xs font-bold">
              4
            </div>
            <div>
              <p className="text-sm text-aurora-text font-medium">Wpisz kod w aplikacji</p>
              <p className="text-xs text-aurora-muted mt-0.5">
                Na ekranie parowania wpisz ten 6-cyfrowy kod. Kod organizacji nie jest już potrzebny
                — kod parowania jednoznacznie identyfikuje urządzenie i organizację.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-500/20 text-green-400 flex items-center justify-center">
              <CheckCircle2 className="w-3.5 h-3.5" />
            </div>
            <div>
              <p className="text-sm text-aurora-text font-medium">Gotowe!</p>
              <p className="text-xs text-aurora-muted mt-0.5">
                Po poprawnym sparowaniu status licencji zmieni się na „Sparowana" i urządzenie
                będzie mogło korzystać z wybranych modułów.
              </p>
            </div>
          </div>

          {/* Serwer wydruku paruje się TAK SAMO — sześcioma cyframi (migracja
              629). Różni się tylko miejscem, w którym kod się wystawia: nie
              jest licencją urządzenia, tylko wpisem w kartotece organu druku,
              więc kod przychodzi z działu Drukowanie. */}
          <p className="text-xs text-aurora-subtle pt-2 border-t border-aurora-border">
            Serwer wydruku paruje się tym samym sześciocyfrowym kodem — wystawia go dział Drukowanie
            → Serwery druku, bo serwer jest wpisem w kartotece druku, a nie licencją urządzenia.
          </p>
        </div>
      )}
    </div>
  );
}
